import { Typography } from "@suraasa/placebo-ui"
import { Masterclass } from "api/resources/masterclasses/types"
import { RefreshDouble } from "iconoir-react"
import { formatDate } from "utils/helpers"

import DEFAULT_MASTERCLASS_IMAGE from "../../assets/Placeholder/default-masterclass-thumbnail.svg"

const ProcessingMasterclass = ({
  masterclass,
}: {
  masterclass: Masterclass
}) => {
  if (!masterclass) return <></>

  return (
    <div className="flex flex-col rounded-lg border border-onSurface-200 p-2 sm:flex-row">
      <img
        alt="thumbnail"
        className="w-full max-w-[167px] rounded-lg"
        src={masterclass.thumbnail ?? DEFAULT_MASTERCLASS_IMAGE}
        onError={e => (e.currentTarget.src = DEFAULT_MASTERCLASS_IMAGE)}
      />
      <div className="flex-auto sm:ml-3">
        <div className="flex flex-col items-start justify-between sm:flex-row sm:items-end">
          <div>
            <Typography
              variant="preTitle"
              className="mt-1 text-onSurface-500 sm:mt-0"
            >
              Masterclass
            </Typography>
            <Typography
              className="first-letter-capitalize mt-1.5 sm:mt-1"
              variant="title3"
            >
              {masterclass.title}
            </Typography>
          </div>
          <div className="mt-0.5 flex shrink-0 flex-row gap-0.5 sm:mt-0 sm:flex-col sm:gap-0 md:flex-row md:gap-0.5">
            <Typography variant="strong">Held On</Typography>
            <Typography variant="body">
              {formatDate(masterclass.startTime, "d MMMM yyyy")}
            </Typography>
          </div>
        </div>
        <div className="mt-2 flex w-full items-center gap-1 rounded-lg bg-highlight-50 px-2 py-1 text-highlight-600">
          <RefreshDouble className="!size-2.5 shrink-0" />
          <Typography variant="strong">
            <span>
              Processing! This masterclass will be available for viewing
              shortly.
            </span>
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default ProcessingMasterclass
